// SrcVer: $Id: //trak/main/adhocs/T2023/6/CLRS25/internal/web/system/module/mainScreen/mainScreen.js#1 $
'use strict';

/**
* @ngdoc directive
* @name tcApp.directive:tcMainscreen
* @element ANY
* @description
* # tcMainScreen
* Resizes a main screen in case there is a button bar
*/
angular.module('tcApp')
.directive('tcMainscreen', function($rootScope, $location, GlobalService) {
	return {
		restrict: 'A',
		scope: true,
		link: function(scope, element) {
			scope.viewModel = {
				disabledSession: ($location.path() === '/DisabledSession')
			};
			
			scope.$watch(function() {return GlobalService.globalContext.showingButtonBar;}, function(newVal) {
				element.toggleClass('showingButtonBar', newVal);
			});
			
			$rootScope.$on('MainScreen:DisableSession', function handleDisableSession() { //eslint-disable-line angular/on-watch
				// Only called where the session has been terminated from another instance
				scope.viewModel.disabledSession = true;
				$location.url('/DisabledSession');
				$rootScope.$digest();
			});
		}
	};
});
